import * as Yup from 'yup';

export const ResetPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('_ERR_EMAIL_REQUIRED email')
    .required('_PARAMETER_IS_REQUEIRED')
});
